import { createScopedDescriptor } from 'quartz/globalState/api';
import { getBuildTimePropertyNames } from 'quartz/globalState/initialize';

// Properties initialized in quartz/globalState/initialize.ts

export const CURRENT_PACKAGE_NAME = createScopedDescriptor(getBuildTimePropertyNames().currentPackageName, 'BROWSING_CONTEXT');
export const CURRENT_PACKAGE_VERSION = createScopedDescriptor(getBuildTimePropertyNames().currentPackageVersion, 'BROWSING_CONTEXT');
export const ROOT_PACKAGE_NAME = createScopedDescriptor(getBuildTimePropertyNames().rootPackageName, 'TAB');
export const ROOT_PACKAGE_VERSION = createScopedDescriptor(getBuildTimePropertyNames().rootPackageVersion, 'TAB');
export const PARENT_PACKAGE_NAME = createScopedDescriptor(getBuildTimePropertyNames().parentPackageName, 'TAB');
export const PARENT_PACKAGE_VERSION = createScopedDescriptor(getBuildTimePropertyNames().parentPackageVersion, 'TAB');